import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
// import { loadStripe } from '@stripe/stripe-js';
// import Header from "../Components/Header/Header";
import { useAuthContext } from "../context/AuthContext";
import { API } from '../constant';
import { getToken } from '../helpers';
import Loading from "../Components/Hooks/Loading";

const Subscription = ({onDataFromChild} ) =>{
    const [subscription, setSubscription] = useState();
    // const [userId, setUserId] =useState();
    const { user } = useAuthContext();
    const [loading, setLoading] = useState(false);
    // let username;
    // const [data, setData] = useState(null);
    // let email;
    let userid;
    if(user!==undefined){
        // console.log(user)
        // username = user.username;
        // email = user.email;
        userid = user.id;
        // setUserId(user.id);
    }
    // console.log(user);

    // const sendDataToParent = () => {
    //     onDataFromChild("My Subscriptions");
    //     };
    useEffect(() => {

        const fetchSubscription = async () => {
        if (!userid) return;
        setLoading(true);
        try {
            const response = await axios.get(
                `${API}/subscriptions?publicationState=preview&filters[userId][id][$eq]=${userid}&sort=createdAt:desc`,
                {
                    headers: { Authorization: `Bearer ${getToken()}` },
                }
            );
            // console.log(response);
            const userSubscription = response.data.data.map((item, i)=>{
            const dateNext = new Date(item.attributes.nextPaymentDate);
            return (
                <tr key={i} id={item.id} className="subscription-item order-item">
                    <td className="subscription-id">#<span>{item.id}</span></td>
                    <td className="subscription-status"><span> {item.attributes.status}</span></td>
                    <td className="subscription-next-payment-date"><span>{`${dateNext.getDate()}-${dateNext.getMonth() + 1}-${dateNext.getFullYear()}`}</span></td>
                    <td><Link to ={`/subscriptions/${item.id}`} ><button className="theme-btn">View</button> </Link> </td>    
                </tr>   
            );
                
        });
        setSubscription(userSubscription);
        setLoading(false);
        } catch (error) {
        console.error(error);
        setLoading(false);
        }
        };
        
        fetchSubscription();
        }, [userid]);
    
    return(         
<div className="my-subscriptions subscription-table">
{loading && <Loading />}

                <div className="table-responsive">
                <table>
                <thead>
                <tr className="order-head order-item subsription-head">
                    <th className="subscription-id"><span>Subscription</span></th>
                    <th className="subscription-status"><span>Status</span></th>
                    <th className="subscription-next-payment-date"><span>Next Payment</span></th>
                    <th className="subscription-amount"><span>Link</span></th>
                </tr>
                </thead>
                <tbody>
                {subscription || null}
                </tbody>
                </table>
                </div>
        </div>         
    );
}
export default Subscription;
